import { ForkEffect, takeEvery } from 'redux-saga/effects';
import { Socket } from 'socket.io-client';

import { send } from '../send-request';
import {
  countryLanguagesAdd,
  countryLanguagesLoad,
  countryLanguagesLoadAllLanguages,
  countryLanguagesRemove,
  countryLanguagesSetPrimary,
} from './reducer';

export function* watch(
  socket: Socket,
): Generator<ForkEffect<never>, void, string> {
  yield takeEvery(countryLanguagesLoad.type, send, socket);
  yield takeEvery(countryLanguagesLoadAllLanguages.type, send, socket);
  yield takeEvery(countryLanguagesAdd.type, send, socket);
  yield takeEvery(countryLanguagesRemove.type, send, socket);
  yield takeEvery(countryLanguagesSetPrimary.type, send, socket);
}
